import {initializeMultipleCarousel} from '../Common/initializeMultipleCarousel';

export var multipleSlidesCount = 0;

export function populateMultipleShowcaseComponent(){
    multipleShowcaseData = jsonData;

    console.log("jsonData: ",jsonData);

    // console.log('recruiterID: ',recruiterID);

    if(recruiterID == '95128' || recruiterID == '25890'){
        $('.multipleShowcase__slide').find('.multipleShowcase__title .icon-location').addClass('hidden');

        $('.multipleShowcase__slide').find('.multipleShowcase__thumbnail').css({"borderRight": "none"});

        // $('.multipleShowcase .multipleShowcase__carousel-container').find('.slick-prev').css({"opacity":"1"});
        // $('.multipleShowcase .multipleShowcase__carousel-container').find('.slick-next').css({"opacity":"1"});
    }

    var multipleShowcaseHeadingText = jsonData.multipleShowcase.section_heading.value;

    if(!$(document).find(".preview").hasClass("hidden")){
        $("#multipleShowcaseHeadingText").html(multipleShowcaseHeadingText);    
    }
    else{          
        $("input#multipleShowcaseHeadingText").val(multipleShowcaseHeadingText);    
    }

    function getComponents() {
        var multipleShowcase = $('.multipleShowcase__slide.prototype.hidden').clone().removeClass('prototype hidden');
        multipleShowcase.addClass("multipleShowcase");
        
        
        return {
            element: multipleShowcase,
            link: multipleShowcase.find(".multipleShowcase__exploreButton"),
            thumbnail: multipleShowcase.find('.thumbnail_image'),
            thumbnailLink: multipleShowcase.find('.thumbnail_link'),
            location: multipleShowcase.find('.multipleShowcase__title'),
        }
    }

    function populateData(jsonData){
        $.each(jsonData.multipleShowcase.data.content, function(index, item) {
                if(multipleSlidesCount<jsonData.multipleShowcase.data.maximum){                    
                    var newVideo = getComponents();
                    // console.log(index, i);
                    if(!$(document).find(".preview").hasClass("hidden")){
                        newVideo.location.find(".title").html(item.location.value);
                        // newVideo.thumbnail.css("cursor", "default");

                        if(item.link){
                            newVideo.link.removeClass("hidden");
                            newVideo.link.attr('href',item.link);
                            newVideo.link.find("button").attr('title', '');
                            newVideo.thumbnailLink.attr("href", item.link);
                        }
                        else{
                            newVideo.location.css("margin-top", "32px"); 
                        }
                    }
                    else{     
                        newVideo.location.find(".title").val(item.location.value);
                        newVideo.link.removeClass("hidden");
                        newVideo.link.attr('data',item.link);
                    }
                    newVideo.thumbnail.attr('src',item.thumbnail.value);
                    newVideo.thumbnail.attr('data-src',item.thumbnail.value);

                    if(item.thumbnail.value.indexOf('_cropped')> -1){
                        newVideo.thumbnail.attr('data-original-src',item.thumbnail.value.split('_cropped')[0] + '.jpg');
                    }
                    else{
                        newVideo.thumbnail.attr('data-original-src',item.thumbnail.value);  
                    }
                    
                    // newVideo.link.attr('data',item.link);
                    // newVideo.descriptionHeading.val(item.descriptionHeading.value);
                    // newVideo.descriptionText.html(item.descriptionText.value);

                    if(multipleSlidesCount>=jsonData.multipleShowcase.data.minimum){
                        newVideo.element.find(".removeMultipleShowcase").removeClass("hidden");
                    }

                    if(multipleSlidesCount>=3){
                        $('.multipleShowcase__carousel-container>.multipleShowcase__slide').css('margin','0 10px');
                        if(!($('.multipleShowcase__carousel-container').hasClass("slick-initialized"))){
                            initializeMultipleCarousel();
                        }            
                        newVideo.element.addClass("carouselElement");
                        // newVideo.element.find(".removeMultipleShowcase").removeClass("hidden");
                        $('.multipleShowcase__carousel-container').slick('slickAdd', newVideo.element);
                        $('.multipleShowcase__carousel-container>.slick-cloned').remove(); 
                    }
                    else{
                        if($(window).width()< 768){
                            if(!($('.multipleShowcase__carousel-container').hasClass("slick-initialized"))){
                                initializeMultipleCarousel();
                            }
                            newVideo.element.addClass("carouselElement");
                            $('.multipleShowcase__carousel-container').slick('slickAdd', newVideo.element);
                            $('.multipleShowcase__carousel-container>.slick-cloned').remove();
                        }
                        else{
                            newVideo.element.css("display", "inline-block");
                            $('.multipleShowcase__carousel-container').append(newVideo.element);
                            $('.multipleShowcase__carousel-container>.multipleShowcase__slide').css('margin','0 10px');
                        }       
                    }
                    multipleSlidesCount++;   
                }
                // console.log("after pops", multipleSlidesCount);
        });
    }

    function addDynamicVideoSlide(){
        var newVideo = getComponents();
        newVideo.element.find(".removeMultipleShowcase").removeClass("hidden");
        $('.multipleShowcase__carousel-container>.multipleShowcase__slide').css('margin', '0 10px');

        // if(multipleSlidesCount<=3 && !($('.multipleShowcase__carousel-container').hasClass("slick-initialized"))){
        //     initializeMultipleCarousel();        
        // }
        // $('.multipleShowcase__carousel-container').slick('slickAdd', newVideo.element);
        // $('.multipleShowcase__carousel-container').find('button.slick-next').click();

        if(multipleSlidesCount>=3){
            if(!($('.multipleShowcase__carousel-container').hasClass("slick-initialized"))){
                initializeMultipleCarousel();
            }      
            newVideo.element.addClass("carouselElement");      
            $('.multipleShowcase__carousel-container').slick('slickAdd', newVideo.element);
            $('.multipleShowcase__carousel-container>.slick-cloned').remove(); 
            $('.multipleShowcase__carousel-container').find('button.slick-next').click();
        }
        else{
            newVideo.element.css("display", "inline-block");
            $('.multipleShowcase__carousel-container').append(newVideo.element);
        }
        newVideo.link.removeClass("hidden");
        newVideo.element.css("background-color", "#cbe4ff");
        window.setTimeout(function(){
            newVideo.element.css("background-color", "#fff"); 
        }, 1000);
        
    }

    $(".addMultipleShowcase").on('click', function(){        
        if(multipleSlidesCount<jsonData.multipleShowcase.data.maximum){
            addDynamicVideoSlide();
            multipleSlidesCount++   
            // console.log("after add", multipleSlidesCount);         
        }
        else{
            toastNotify(3,"You have acheived the maximum limit.");
        }
    });   

    $(".multipleShowcase__carousel-container").on('click', ".removeMultipleShowcase" ,function(){          
        $(this).parent().remove();
        $(".multipleShowcase__carousel-container").find('.slick-arrow').remove();
        $(".multipleShowcase__carousel-container").slick('reinit');
        multipleSlidesCount--;     
        // console.log("after remove", multipleSlidesCount);
        if(multipleSlidesCount<3){
            $('.multipleShowcase__carousel-container').slick('unslick');
            $('.multipleShowcase__carousel-container').find(".carouselElement").remove()
            $('.multipleShowcase__carousel-container>.multipleShowcase__slide').css('margin', '0 10px');
            $(".multipleShowcase__carousel-container").find('.slick-arrow').remove();
        }   
    });

    populateData(jsonData);

    // $(".multipleShowcase__slide.multipleShowcase").on('click', '.thumbnail_link', function(e){
    //     e.preventDefault();

    //     if($(this).attr("href") != "#"){
    //         window.open($(this).attr("href"), '_blank');
    //     }
    // });

    // $(".multipleShowcase__slide.multipleShowcase").on('click', '.multipleShowcase__exploreButton', function(e){
    //     e.preventDefault();

    //     if($(this).attr("href") != "#"){
    //         window.open($(this).attr("href"), '_blank');
    //     }
    // });

    $(".multipleShowcase__carousel-container").on('click', '.multipleShowcase__slide.multipleShowcase .thumbnail_link', function(e){
        e.preventDefault();

        if($(this).attr("href") != "#"){
            window.open($(this).attr("href"), '_blank');
        }
    });

    $(".multipleShowcase__carousel-container").on('click', '.multipleShowcase__slide.multipleShowcase .multipleShowcase__exploreButton', function(e){
        e.preventDefault();

        if($(this).attr("href") != "#"){
            window.open($(this).attr("href"), '_blank');
        }
    });
}